import React from 'react';
import clsx from 'clsx';
import { ButtonStyled, ModalActionsStyled } from '@nike/nike-design-system-components';
import { useModal } from '@nike/podium-dialog-manager';
import {
  inlineButton,
  koreaModalButton,
  koreaModalMain,
  KoreanLegalModal,
  KoreanModalContentContainer,
  KoreanModalInnerText,
  link,
} from './style';
import Link from '../Link';
import useBodega from '../../utils/hooks/bodegaHook';
import { BODEGA_DEFAULTS } from '../../constants';

const baseClickEventPayload = { type: 'click_navFooter', props: { path: '' } };

/**
 * Korean Learn More Modal
 * returns JSX.Element
 */
const KoreanLearnMoreModal = () => {
  const { isOpen, openModal, closeModal } = useModal();

  const closeModalLabel = useBodega('nav_close_modal', BODEGA_DEFAULTS.CLOSE_MODAL);
  const modalTitle = useBodega('nav_sub_footer_modal_title', BODEGA_DEFAULTS.KOREAN_MODAL_TITLE);
  const modalTextOne = useBodega(
    'nav_sub_footer_modal_body_text_one',
    BODEGA_DEFAULTS.KOREAN_MODAL_TEXT_1,
  );
  const modalTextTwo = useBodega(
    'nav_sub_footer_modal_body_text_two',
    BODEGA_DEFAULTS.KOREAN_MODAL_TEXT_2,
  );
  const modalTextThree = useBodega(
    'nav_sub_footer_modal_body_text_three',
    BODEGA_DEFAULTS.KOREAN_MODAL_TEXT_3,
  );
  const modalBtnText = useBodega('nav_cookie_label_done', BODEGA_DEFAULTS.DONE);

  const Actions = () => (
    <ModalActionsStyled className={'modal-actions-styled'}>
      <ButtonStyled
        appearance="primary"
        className={clsx('responsive-btn', koreaModalButton)}
        onClick={closeModal}
      >
        {modalBtnText}
      </ButtonStyled>
    </ModalActionsStyled>
  );

  return (
    <>
      <Link
        className={clsx(inlineButton, link)}
        clickEventPayload={{
          ...baseClickEventPayload,
          props: {
            path: 'confidential content business development act',
          },
        }}
        data-var="koreanContentProtectionBtn"
        onClick={openModal}
      >
        {useBodega('nav_legal_info_link_text', BODEGA_DEFAULTS.READ_MORE)}
      </Link>
      <KoreanLegalModal
        classes={{
          main: koreaModalMain,
        }}
        closeModal={closeModal}
        data-testid="koreanModal"
        isOpen={isOpen}
        modalCloseAriaLabel={closeModalLabel}
        slots={{ FooterSlot: <Actions /> }}
        title={modalTitle}
      >
        <KoreanModalContentContainer className="pre-korean-legal-footer-modal-content">
          <KoreanModalInnerText>{modalTextOne}</KoreanModalInnerText>
          <KoreanModalInnerText>{modalTextTwo}</KoreanModalInnerText>
          <KoreanModalInnerText>{modalTextThree}</KoreanModalInnerText>
        </KoreanModalContentContainer>
      </KoreanLegalModal>
    </>
  );
};

export default KoreanLearnMoreModal;
